module.exports = __webpack_public_path__ + "01ff1fe5b48a5ae086b4a656e702401d.pdf";